import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserRoleNames } from 'src/app/core/models/users';
import { RouteGuard } from 'src/app/core/route-guards/route-guard.guard';
import { GatewayListComponent } from './components/gateway-list/gateway-list.component';

const routes: Routes = [
  // {
  //   path: 'Gateway List',
  //   component: GatewayMainPanelComponent,
  //   canActivateChild: [RouteGuard],
  //   data: {role: [UserRoleNames.GlobalAdmin, UserRoleNames.PowerUser, UserRoleNames.DeploymentAdmin]},
  //   children: [
  //     { path: 'Gateways', component: GatewayListComponent},
  //     { path: 'Logs', component: GatewayLogsComponent},
  //     { path: '', pathMatch: 'full', redirectTo: 'Gateways'}
  //   ],
  // },
  {
    path: 'Gateway List',
    component: GatewayListComponent,
    canActivateChild: [RouteGuard],
    data: {role: [UserRoleNames.GlobalAdmin, UserRoleNames.PowerUser, UserRoleNames.DeploymentAdmin]},
  },
  // {
  //   path: 'Gateway List',
  //   component: GatewayMainPanelComponent,
  //   canActivateChild: [RouteGuard],
  //   data: {role: [UserRoleNames.GlobalAdmin, UserRoleNames.PowerUser, UserRoleNames.DeploymentAdmin]},
  //   children: [
  //     { path: 'Gateways', component: GatewayListComponent},
  //     { path: 'Logs', component: GatewayLogsComponent},
  //     { path: '', pathMatch: 'full', redirectTo: 'Gateways'}
  //   ],
  // },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GatewayRoutingModule { }
